<template>
  <div style="background-color: #2F80ED">
    <Mainlayout></Mainlayout>
    <CContainer>
      <br />
      <br />
      <br />
      <div class="title-demo mt-5">
        Elevate Your Student Management to improve efficiency
      </div>
      <br />
      <div class="summary-title">
        Receive a demonstration designed to meet the specific needs of your
        education business, with the ability to expand to multiple branches with
        ease.
      </div>
      <br /><br />
      <!-- popup md -->
      <div class="custom-popup-class-demo d-sm-down-none" style="z-index: 1">
        <div style="background: rgba(13, 197, 255, 0.57);">
          <br />
          <div>
            <div class="title-reg text-center">Register your interest!</div>
            <h3 class="custom-24px text-left text-white mt-4 p-2">
              <br />
              <img
                src="../assets/img/iconBackWhite.svg"
                class="mr-2"
                @click="ClosePopup()"
              />
            </h3>
            <div v-if="popupform === true">
              <div v-if="Error == true" class="ml-4 mr-4">
                <CAlert show color="danger">
                  <strong class="text-danger mr-2"
                    >X ERROR ! Please complete all the form in the following
                    below
                  </strong>
                </CAlert>
              </div>
              <div>
                <div class="text-center">
                  <img
                    style="max-width: 100%; height: 350px"
                    src="../assets/img/Selfstar.png"
                    class="p-4"
                  />
                </div>
                <div class="card-custom-web">
                  <CContainer>
                  <div class="p-5">
                    <h5 class="mt-2 ml-3 mb-3">
                      <b class="title-contact text-center"
                        >Let us contact you for the Demo!
                      </b>
                    </h5>
                    <CRow>
                      <CCol sm="1">
                        <img src="../assets/img/book.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Enter your name</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Name"
                          :disabled="isSubmitting"
                          placeholder="e.g. alif syukri"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/email.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Email Address</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Email"
                          :disabled="isSubmitting"
                          placeholder="e.g. alif.syukri@gmail.com"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/iconphone.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Phone No.</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Mobile"
                          :disabled="isSubmitting"
                          placeholder="e.g. 01912345678"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/iconbookmark.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Institution name</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Institution"
                          :disabled="isSubmitting"
                          placeholder="e.g. Private School Paris City"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/iconsubject.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Message to us</strong>
                        </h4>
                      </CCol>

                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Message"
                          :disabled="isSubmitting"
                          placeholder="e.g. Please contact me as soon as possible"
                        />
                        <br />

                        <div v-if="SubmittedForm === true">
                          <h5>
                            <label class="text-center"
                              ><i
                                >Our marketing team will contact you as soon as
                                possible</i
                              ></label
                            >
                          </h5>
                          <br />
                          <CButton color="success" size="md" block disabled
                            >Submitted</CButton
                          >
                        </div>
                        <div v-else>
                          <CButton
                            color="info"
                            size="sm"
                            block
                            class="custom-btn-login-forgot"
                            :disabled="isDisabled"
                            @click="SubmitForm"
                            >Submit</CButton
                          >
                        </div>
                      </CCol>
                    </CRow>
                  </div>
                 
                  <div>
                    <CRow>
                      <CCol sm="2">
                        <img
                          style="max-width: 100%; height: 90px"
                          src="../assets/img/mastermaths.svg"
                          class="p-2"
                      /></CCol>
                      <CCol sm="2">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/mawartuition.svg"
                          class="p-2"
                      /></CCol>
                      <CCol sm="2">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/johan.svg"
                          class="p-2"
                      /></CCol>
                      <CCol sm="2">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/msa.svg"
                          class="p-2"
                      /></CCol>
                      <CCol sm="2">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/ptti.svg"
                          class="p-2"
                      /></CCol>
                      <CCol sm="2">
                        <img
                          style="max-width: 100%"
                          src="../assets/img/lollipop.svg"
                          class="p-2"
                      /></CCol>
                    </CRow>
                  </div>
                  <div>
                    <CRow>
                    <CCol sm="7">
                      <div>
                        <label class="custom-profile-info mt-5 p-3">
                          <br />
                             <strong> "As a coach for Paralympic athletics, I have found
                              that Pickiddo has simplified my training schedule
                              and payments, and made everything much more
                              organized. The added bonus is that the Pickiddo
                              app allows for seamless communication and
                              management between my business and the parents of
                              my students, making student activities even more
                              systematic"</strong>
                      </label>
                      </div>
                    </CCol>
                    <CCol sm="5">
                      <img style="max-width:100%" src="../assets/img/icon/suhaidin.png" class="mt-5"/>
                      <div class="text-center">
                        <br />
                       <strong> <i>Ex Malaysia Paralympic Coach.</i></strong><br />
                        Business owner MSA GEWO Sport Centre 
                      </div>
                      <br /> <br /> 
                    </CCol>
                  </CRow>
                  </div>
                </CContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- popup sm -->
      <div class="custom-popup-class-demo d-md-none" style="z-index: 1">
        <div style="background: rgba(13, 197, 255, 0.57);">
          <div>
            <h3 class="custom-24px text-left text-white mt-4 p-2">
              <br /><br />
              <img
                src="../assets/img/iconBackWhite.svg"
                class="mr-2"
                @click="ClosePopup()"
              />
              <span class="text-center ml-3"> Register your interest</span>
            </h3>
            <div v-if="popupform === true">
              <div v-if="Error == true" class="ml-4 mr-4">
                <CAlert show color="danger">
                  <strong class="text-danger mr-2"
                    >X ERROR ! Please complete all the form in the following
                    below
                  </strong>
                </CAlert>
              </div>
              <div>
                <div class="text-center">
                  <img
                    style="max-width: 100%; height: 200px"
                    src="../assets/img/Selfstar.png"
                    class="p-4"
                  />
                </div>

                <div class="card-custom-web">
                  <div
                    class="p-3">
                  <h5 class="mt-2 ml-3 mb-3">
                      <b class="title-contact text-center"
                        >Let us contact you for the Demo!
                      </b>
                    </h5>
                    <CRow>
                      <CCol sm="1">
                        <img src="../assets/img/book.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Enter your name</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Name"
                          :disabled="isSubmitting"
                          placeholder="e.g. alif syukri"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/email.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Email Address</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Email"
                          :disabled="isSubmitting"
                          placeholder="e.g. alif.syukri@gmail.com"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/iconphone.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Phone No.</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Mobile"
                          :disabled="isSubmitting"
                          placeholder="e.g. 01912345678"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/iconbookmark.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Institution name</strong>
                        </h4>
                      </CCol>
                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Institution"
                          :disabled="isSubmitting"
                          placeholder="e.g. Private School Paris City"
                        />
                      </CCol>

                      <CCol sm="1">
                        <img src="../assets/img/iconsubject.svg" />
                      </CCol>
                      <CCol sm="10">
                        <h4 class="custom-16px-blue">
                          <strong>Message to us</strong>
                        </h4>
                      </CCol>

                      <CCol sm="12" class="mb-2">
                        <input
                          type="text"
                          class="custom-input-user mb-2"
                          v-model="Message"
                          :disabled="isSubmitting"
                          placeholder="e.g. Please contact me as soon as possible"
                        />
                        <br />

                        <div v-if="SubmittedForm === true">
                          <h5>
                            <label class="text-center"
                              ><i
                                >Our marketing team will contact you as soon as
                                possible</i
                              ></label
                            >
                          </h5>
                          <br />
                          <CButton color="success" size="md" block disabled
                            >Submitted</CButton
                          >
                        </div>
                        <div v-else>
                          <CButton
                            color="info"
                            size="sm"
                            block
                            class="custom-btn-login-forgot"
                            :disabled="isDisabled"
                            @click="SubmitForm"
                            >Submit</CButton
                          >
                        </div>
                      </CCol>
                    </CRow>
                  </div>

                  <div>
                    <CRow>
                      <div class="text-center">
                        <img
                          style="max-width: 100%; height: 90px"
                          src="../assets/img/mastermaths.svg"
                          class="p-2"
                      />
                        <img
                          style="max-width: 100%"
                          src="../assets/img/mawartuition.svg"
                          class="p-2"
                      />
                        <img
                          style="max-width: 100%"
                          src="../assets/img/johan.svg"
                          class="p-2"
                      />
                        <img
                          style="max-width: 100%"
                          src="../assets/img/msa.svg"
                          class="p-2"
                      />
                        <img
                          style="max-width: 100%"
                          src="../assets/img/ptti.svg"
                          class="p-2"
                      />
                        <img
                          style="max-width: 100%"
                          src="../assets/img/lollipop.svg"
                          class="p-2"
                      />
                    </div>
                    </CRow>
                  </div>
                  <div>
                    <CRow>
                    <CCol sm="7">
                      <div>
                        <label class="custom-profile-info p-3">
                          <br />
                             <strong> "As a coach for Paralympic athletics, I have found
                              that Pickiddo has simplified my training schedule
                              and payments, and made everything much more
                              organized. The added bonus is that the Pickiddo
                              app allows for seamless communication and
                              management between my business and the parents of
                              my students, making student activities even more
                              systematic"</strong>
                      </label>
                      </div>
                    </CCol>
                    <CCol sm="5">
                    
                      <div class="text-center">
                        <img style="max-width:100%" src="../assets/img/icon/suhaidin.png"/>
                        <br /> <br />
                       <strong> <i>Ex Malaysia Paralympic Coach.</i></strong><br />
                        Business owner MSA GEWO Sport Centre 
                        <br /> <br />  <br /><br /><br /><br />
                      </div>
                    </CCol>
                    <br /><br /><br /><br />
                  </CRow>
                  </div>
             
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <Footerlayout></Footerlayout>
  </div>
</template>




<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";




// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
    VueCal,
    MenuIcon,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout,
  },
  data() {
    return {
      slides: 5,
      selectedGrade: "SELECT GRADE",
      selectedGradeAll: "SELECT GRADE",
      gradeOptions: [],
      FilteredGrades: [],

      FilteredGradesAll: [],

      counter: "",
      round: "",

      scheduleclass: true,
      others: false,

      isShowPrimary: true,
      isShowSecondary: false,

      popupdetail: false,
      popupform: true,

      SubmitDataDone: false,
      SubmitData: true,

      Name: "",
      Email: "",
      Institution: "",
      Message: "",
      Mobile: "",
      isSubmitting: false,

      SubmittedForm: false,
      Error: false,
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    this.GetScheduleStudent();
    this.GetScheduleStudentAll();
    this.GetCounter();

    // if (window.location.hostname !== 'www.pickiddo.com') {
    //     window.location.href = 'https://www.pickiddo.com'
    // }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {
    values: {
      get: function () {
        var t = this.counter;
        console.log("test" + t);
        return t;
      },
    },
    valuesTotal: {
      get: function () {
        var t = 30876;
        console.log("test" + t);
        return t;
      },
    },
  },

  methods: {
    ReloadButton() {
      window.open("https://www.pickiddo.com/home", "_self");
    },
    async GetCounter() {
      this.$API
        .get(this.$CounterClass, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.counter = response.data;
          }
        });
    },
    GotoWhatssap() {
      location.replace(
        "https://wa.me/600106597700?text=+Hi, I would like to ask about One To One"
      );
    },
    async GetCounter() {
      this.$API
        .get(this.$CounterClass, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.counter = response.data;
          }
        });
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    ClosePopup() {
      this.popupdetail = false;
    },
    OpenPopup() {
      this.popupdetail = true;
    },
    SubmitForm() {
      if (
        this.Name === "" ||
        this.Email === "" ||
        this.Mobile === "" ||
        this.Institution === "" ||
        this.Message === ""
      ) {
        this.Error = true;
        this.isSubmitting = false;
        this.SubmittedForm = false;
      } else {
        this.Error = false;
        this.isSubmitting = true;
        this.SubmittedForm = true;
        const formData = new FormData();

        formData.append("Name", this.Name);
        formData.append("Email", this.Email);
        formData.append("Mobile", this.Mobile);
        formData.append("Institution", this.Institution);
        formData.append("Message", this.Message);

        return this.$API
          .post(this.$InsertRegisterDemo, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (
              response.status == 200 &&
              response.data != null &&
              response.data > 0
            ) {
              this.successModal = true;
            } else {
              this.errorModal = true;
            }
          })
          .catch((error) => {
            if (error.response) {
              console.log(error.response.status);
              this.Error = true;
              this.Message = error;
              this.Message = "Error";
            }
          });
      }
    },
    GoToApp() {
      this;
    },
  },
};
</script>
    <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-header {
  /* background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83; */

  background: transparent;
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: "Montserrat", sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Montserrat", sans-serif;
}
label {
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: "Montserrat";
  font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
  top: 0 !important;
  font-family: "Montserrat", sans-serif;
}
li {
  font-family: "Montserrat", sans-serif;
}
.centered {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.card-custom-web {
  left: 0px;
  margin-top: 0px;
  width: 100%;
  background: #f9f9f9;
  -webkit-box-shadow: 0px 4px 20px rgb(0 0 0 / 8%);
  box-shadow: 0px 4px 20px rgb(0 0 0 / 8%);
  border-radius: 50px 0px 0px 0px;
  color: #000;
}

input {
  border-bottom: 2px solid #007cef;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
}

.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
.title-demo {

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: xx-large;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.summary-title {

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: x-large;

  /* Pure/White */

  color: #ffffff;
}
.title-reg {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;

  color: #ffffff;
}
.title-contact {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;

  /* #000A2C */

  color: #000a2c;
}
.sub-title-demo {
    position: absolute;

font-family: 'Montserrat';
font-style: italic;
font-weight: 500;
font-size: 20px;
line-height: 24px;

color: #000A2C;
}
</style>